import { render, staticRenderFns } from "./CreateTicketMenu.vue?vue&type=template&id=dda55d98"
import script from "./CreateTicketMenu.vue?vue&type=script&lang=js"
export * from "./CreateTicketMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports